import React, { useState } from 'react';
import { X, Save } from 'lucide-react';
import { db } from '../lib/db';

interface NoteEditorProps {
  verseId: string;
  reference: string;
  initialContent?: string;
  onClose: () => void;
  onSave: () => void;
}

export function NoteEditor({ verseId, reference, initialContent = '', onClose, onSave }: NoteEditorProps) {
  const [content, setContent] = useState(initialContent);

  const handleSave = async () => {
    try {
      await db.notes.add({
        verseId,
        content,
        tags: [],
        createdAt: new Date(),
        updatedAt: new Date()
      });
      onSave();
      onClose();
    } catch (error) {
      console.error('Error saving note:', error);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center p-4 z-50">
      <div className="bg-slate-800 rounded-lg w-full max-w-2xl border border-white/10">
        <div className="flex justify-between items-center p-4 border-b border-white/10">
          <h3 className="text-lg font-semibold text-white">Note for {reference}</h3>
          <button onClick={onClose} className="text-white/60 hover:text-white">
            <X size={20} />
          </button>
        </div>
        <div className="p-4">
          <textarea
            value={content}
            onChange={(e) => setContent(e.target.value)}
            className="w-full h-48 p-3 bg-white/5 border border-white/10 rounded-lg text-white placeholder-white/50 focus:ring-2 focus:ring-gold-400 focus:border-gold-400"
            placeholder="Write your thoughts, insights, and reflections..."
          />
          <div className="flex justify-end gap-3 mt-4">
            <button
              onClick={onClose}
              className="px-4 py-2 text-white/60 hover:text-white hover:bg-white/10 rounded-lg"
            >
              Cancel
            </button>
            <button
              onClick={handleSave}
              className="px-4 py-2 bg-gold-400 text-slate-900 rounded-lg hover:bg-gold-500 flex items-center gap-2"
            >
              <Save size={18} />
              <span>Save Note</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}